var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"preview",attrs:{"href":"https://issuu.com/rosinanteco/docs/tryk_og_glad_laeseproeve","target":"_blank"}},[_c('btn',{attrs:{"secondary":""}},[_vm._v("Læs en smagsprøve")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }